import { Checkbox } from '@ordo/ui/checkbox'
import { getApiErrorMessage } from 'hooks/useFetchApi'

export function RecognizedOnlyField({
  id,
  checked,
  onChange,
  disabled,
}: {
  id: string
  checked: boolean
  onChange: (value: boolean) => void
  disabled?: boolean
}) {
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="flex items-start gap-2 text-sm">
        <Checkbox
          id={id}
          className="mt-0.5"
          checked={checked}
          onCheckedChange={(value) => onChange(value === true)}
          disabled={disabled}
        />
        Forward recognized contacts only
      </label>
      <p className="text-xs text-muted-foreground">
        When enabled, messages from unknown or ambiguous senders are retained without being forwarded.
      </p>
    </div>
  )
}

export function InboundError({ error }: { error: unknown }) {
  return (
    <p role="alert" className="mb-4 break-words rounded-md border border-destructive/30 p-3 text-sm text-destructive">
      {getApiErrorMessage(error)}
    </p>
  )
}
